import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionsPage } from "@/features/me/SubscriptionsPage";

export const Route = createFileRoute("/app/me/subscriptions")({ component: SubscriptionsPage });
